import { render, staticRenderFns } from "./OpportunitiesAdd.vue?vue&type=template&id=5cdaf522&"
import script from "./OpportunitiesAdd.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports